import './styles.scss';

import { ReactElement, Ref, forwardRef } from 'react';

import FormatInput from '@/common/FormatInput';
import { FormatInputTypes } from '@/common/FormatInput/types';
import { InputTypes } from '@/common/Input/types';
import { formatPhoneNumber } from '@/common/PhoneInput/utils';
import { getClasses } from '@/utils';

export type PhoneInputProps = Omit<FormatInputTypes.Props, 'type'>;

const PhoneInput = forwardRef<InputTypes.RefType, PhoneInputProps>(
  ({ ...props }: PhoneInputProps, ref: Ref<InputTypes.RefType>): ReactElement => (
    <FormatInput
      onFormat={formatPhoneNumber}
      {...props}
      className={getClasses('PhoneInput', 'Common', props.className)}
      pattern={(value: string): string => {
        value = value.replace(/^ +/, '');
        if (value.startsWith('+')) return '+' + value.slice(1).replace(/[^0-9() -]/g, '');
        return value.replace(/[^0-9() -]/g, '');
      }}
      ref={ref}
    />
  )
);
PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
